<template>
    <div
        v-loading="loading" 
        element-loading-text="正在加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(23, 40, 90)" style="display: flex;justify-content: center;align-items: center;width: 99%;height: 99%;padding: 1.5% 2%">
        <dv-scroll-board :config="config" style="width:100%;height:99%" />
    </div>
</template>

<script>
import util from "@/util";
import store from "@/store";
import { mapState } from "vuex";
export default {
    data() {
        return{
            loading: true,
            // config: null,
            config: {
                headerBGC: '#00093a',
                oddRowBGC: '#00093a',
                evenRowBGC: '#00093a',
                columnWidth: [210],
                header: ['站点', '充电车次', '充电量(KW.H)'],
                align: ['center','center','center'],
                rowNum: 5,
                waitTime: 5000,
                data: [
                    ['行1列1', '行1列2', '行1列3'],
                    ['行2列1', '行2列2', '行2列3'],
                    ['行3列1', '行3列2', '行3列3'],
                    ['行4列1', '行4列2', '行4列3'],
                    ['行5列1', '行5列2', '行5列3'],
                    ['行6列1', '行6列2', '行6列3'],
                    ['行7列1', '行7列2', '行7列3'],
                    ['行8列1', '行8列2', '行8列3'],
                    ['行9列1', '行9列2', '行9列3'],
                    ['行10列1', '行10列2', '行10列3']
                ]
            }
        }
    },
    mounted() {
        this.getSiteOrderSummary()
    },
    watch: {
        siteOrderSummary: {
            handler(val) {
                console.log(val)
                let datas = [].concat(val);
                datas.sort(function(a,b){return a.power.toFixed(0)-b.power.toFixed(0)}).reverse()
                let data = []
                for(let i = 0;i<datas.length;i++) {
                    data.push([
                        datas[i].name,datas[i].order_count * this.multiple,(datas[i].power*this.multiple).toFixed(2)
                    ])
                }
                this.config.data = JSON.parse(JSON.stringify(data)).concat([]); 
                this.config = { ...this.config }
            },
            deep: true,
        },
    },
    computed: {
        ...mapState(["siteOrderSummary","multiple"]),
    },
    methods: {
        async getSiteOrderSummary() {
            let date = new Date()
            let year = date.getFullYear()
            let month = date.getMonth()
            let start_time = new Date(year,month,1).getTime()
            let end_time = new Date(year,month+1,0).getTime() + + 24 * 60 * 60 * 1000
            let that = this;
            let params = {
                postData: {
                    end_time: parseInt(end_time / 1000),
                    start_time: parseInt(start_time / 1000),
                    sum_type: 2,
                },
                callback: () => {
                   that.loading  = false;
                },
            };
            await store.dispatch("getOrderSummary", params);
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .row-item {
    // min-height: 2rem;
}
::v-deep .ceil{
    color:  #00c0ff;
    // min-height: 2rem;
}
// ::v-deep .ceil:nth-child(1){
//     color:  #91cc75;
// }
::v-deep .ceil:nth-child(2){
    color:  #1fc792;
}
::v-deep .ceil:nth-child(3){
    color:  #00c0ff;
}
::v-deep .dv-scroll-board .header .header-item {
    color:  #00c0ff;
}
</style>